/**
 * @documental
 * @export Item
 * @name
 * Menu.Item
 */

import { FC, ReactNode } from "react";
import { ItemClickEventHandler } from "./ItemClickEventHandler";
import { BaseProps } from "../../BaseProps";

/**
 * The `Item` component properties.
 */
export interface ItemProps extends BaseProps {
  /**
   * The item type. If not specified defaults to `"normal"`.
   */
  readonly type?: "normal" | "high-impact";

  /**
   * Indicates whether the item is disabled. If not specified defaults to `false`.
   */
  readonly disabled?: boolean;

  /**
   * The button tooltip.
   */
  readonly tooltip?: ReactNode;

  /**
   * The item children.
   */
  readonly children?: ReactNode;

  /**
   * Function to call when the item is clicked.
   */
  readonly onClick?: ItemClickEventHandler;
}

/**
 * A single item for the `Menu` component.
 */
export const Item: FC<ItemProps> = () => {
  return null;
};
